export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/0f411c8c76e445c4.png"